/**
 * Videos shown inside the /apply wizard.
 *
 * While the wizard is dark behind the `enable-audition-wizard` flag neither
 * video has been produced, so both point at the same YouTube placeholder.
 * When the real recordings land they will live on Mux like the courses
 * videos — swap a `source` to `{ provider: 'mux', playbackId: '...' }` and
 * nothing else changes. The two entries are already separate so that
 * happens one video at a time.
 */
export type IntroVideoSource =
  | { provider: 'youtube'; id: string }
  | { provider: 'mux'; playbackId: string }

export interface AuditionVideo {
  /**
   * Stable identity for this video, and the only thing seen-state is keyed
   * on. Deliberately not the YouTube/Mux id: swapping the placeholder for
   * the real recording must NOT un-see the video for everyone who already
   * watched it, and re-cutting a video that people should re-watch is done
   * by choosing a new `id` here.
   */
  id: string
  source: IntroVideoSource
  /** Overlaid on the player. Says what the viewer is about to spend time on. */
  caption: string
}

/** Plays on the welcome screen, ahead of step 1. */
export const WELCOME_VIDEO: AuditionVideo = {
  id: 'welcome-2026-09',
  source: { provider: 'youtube', id: 'dQw4w9WgXcQ' },
  caption: 'A two-minute hello before you start',
}

/**
 * The mid-flow video. Which step carries it is a data choice made in
 * `WIZARD_STEPS` / `QUESTION_STEPS`, not here — moving it is an edit to
 * one `video:` property in steps.ts.
 */
export const MID_FLOW_VIDEO: AuditionVideo = {
  id: 'mid-flow-2026-09',
  source: { provider: 'youtube', id: 'dQw4w9WgXcQ' },
  caption: 'Two minutes on why we ask this, and why we keep the group small',
}
